module.exports = __webpack_public_path__ + "assets/img/wa-sudare.317d5743.svg";